import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const getModules = () => api.get('/api/modules').then((r) => r.data);
export const getModule = (id) => api.get(`/api/modules/${id}`).then((r) => r.data);
export const updateModule = (id, data) => api.put(`/api/modules/${id}`, data).then((r) => r.data);
export const createModule = (data) => api.post('/api/modules', data).then((r) => r.data);
export const deleteModule = (id) => api.delete(`/api/modules/${id}`).then((r) => r.data);

export const createTopic = (moduleId, data) =>
  api.post(`/api/modules/${moduleId}/topics`, data).then((r) => r.data);
export const updateTopic = (moduleId, topicId, data) =>
  api.put(`/api/modules/${moduleId}/topics/${topicId}`, data).then((r) => r.data);
export const deleteTopic = (moduleId, topicId) =>
  api.delete(`/api/modules/${moduleId}/topics/${topicId}`).then((r) => r.data);

export const createInvite = (role, email) =>
  api.post('/api/auth/create-invite', { role, email: email || null }).then((r) => r.data);

export const uploadFile = (file, onProgress) => {
  const form = new FormData();
  form.append('file', file);
  return api
    .post('/api/upload', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: (e) => {
        if (onProgress && e.total) onProgress(Math.round((e.loaded * 100) / e.total));
      },
    })
    .then((r) => r.data);
};

// ─── Phase 1.7 — Rubrics + Submissions ─────────────────────────────────────
export const listRubrics = (params = {}) =>
  api.get('/api/rubrics', { params }).then((r) => r.data);
export const getRubric = (id) => api.get(`/api/rubrics/${id}`).then((r) => r.data);
export const createRubric = (data) => api.post('/api/rubrics', data).then((r) => r.data);
export const updateRubric = (id, data) => api.put(`/api/rubrics/${id}`, data).then((r) => r.data);
export const deleteRubric = (id) => api.delete(`/api/rubrics/${id}`).then((r) => r.data);

export const createSubmission = (data) =>
  api.post('/api/submissions', data).then((r) => r.data);
export const listSubmissionsForRubric = (rubricId) =>
  api.get(`/api/rubrics/${rubricId}/submissions`).then((r) => r.data);
export const getSubmission = (subId) =>
  api.get(`/api/submissions/${subId}`).then((r) => r.data);
export const aiScoreSubmission = (subId) =>
  api.post(`/api/submissions/${subId}/ai-score`).then((r) => r.data);
export const finalizeSubmission = (subId, finalScores) =>
  api.put(`/api/submissions/${subId}/finalize`, { final_scores: finalScores }).then((r) => r.data);

// ─── Phase 1.7c — Chat Efficiency Analytics ────────────────────────────────
export const getChatEfficiency = (params = {}) =>
  api.get('/api/analytics/chat-efficiency', { params }).then((r) => r.data);
export const getChatEfficiencyTimeline = (email, params = {}) =>
  api.get('/api/analytics/chat-efficiency/timeline', { params: { email, ...params } }).then((r) => r.data);
export const getExecutiveDashboard = (params = {}) =>
  api.get('/api/analytics/executive', { params }).then((r) => r.data);

// ─── Phase 1.7d — Discussion auto-scoring + Curving ────────────────────────
export const listDiscussionThreads = (params = {}) =>
  api.get('/api/discussions', { params }).then((r) => r.data);
export const autoScoreDiscussion = (threadId, body) =>
  api.post(`/api/discussions/${threadId}/auto-score`, body).then((r) => r.data);
export const curvePreview = (rubricId, body) =>
  api.post(`/api/rubrics/${rubricId}/curve-preview`, body).then((r) => r.data);
export const curveApply = (rubricId, body) =>
  api.post(`/api/rubrics/${rubricId}/curve-apply`, body).then((r) => r.data);
export const curveClear = (rubricId) =>
  api.delete(`/api/rubrics/${rubricId}/curve`).then((r) => r.data);

// ─── Phase 1.7e — Course Gradebook (composite + course curve) ──────────────
export const getGradebookConfig = () =>
  api.get('/api/gradebook/config').then((r) => r.data);
export const updateGradebookConfig = (weights) =>
  api.put('/api/gradebook/config', { weights }).then((r) => r.data);
export const getGradebookCohort = (params = {}) =>
  api.get('/api/gradebook/cohort', { params }).then((r) => r.data);
export const courseCurvePreview = (body, params = {}) =>
  api.post('/api/gradebook/curve-preview', body, { params }).then((r) => r.data);
export const courseCurveApply = (body, params = {}) =>
  api.post('/api/gradebook/curve-apply', body, { params }).then((r) => r.data);
export const courseCurveClear = (params = {}) =>
  api.delete('/api/gradebook/curve', { params }).then((r) => r.data);
export const getMyGrades = () =>
  api.get('/api/gradebook/me').then((r) => r.data);


// ─── Phase 2.0 — Canvas LTI 1.3 ─────────────────────────────────────────────
export const getLtiConfig = () =>
  api.get('/api/lti/config').then((r) => r.data);
export const listLtiTenants = () =>
  api.get('/api/lti/tenants').then((r) => r.data);
export const createLtiTenant = (body) =>
  api.post('/api/lti/tenants', body).then((r) => r.data);
export const deleteLtiTenant = (tenantId) =>
  api.delete(`/api/lti/tenants/${tenantId}`).then((r) => r.data);
export const getLtiLaunchContext = (launchId) =>
  api.get(`/api/lti/launch-context/${launchId}`).then((r) => r.data);
